const FIELD_TERM = /(^|\s)\w+:/;
// STAT_TERM (Trigger im Gesamtstring) und STAT_TOKEN (Klassifikation je Token) müssen
// dasselbe Muster tragen — Wert ist Pflicht, kompakt wie im Backend-Parser (searchSyntax.ts).
const STAT_TERM = /(^|\s)(pow|power|tou|toughness)(!=|<=|>=|=|<|>)(-?\d+|\*|x)(?=\s|$)/i;
const STAT_TOKEN = /^(pow|power|tou|toughness)(!=|<=|>=|=|<|>)(-?\d+|\*|x)$/i;

export function hasSyntaxTerms(input) {
  return Boolean(input) && (FIELD_TERM.test(input) || STAT_TERM.test(input));
}

export function splitCombinedSearch(input) {
  if (!hasSyntaxTerms(input)) return { name: input || '', syntax: '' };
  const tokens = input.match(/(?:\w+:"[^"]*"|\w+:\S+|\S+)/g) || [];
  const nameTokens = [];
  const syntaxTokens = [];
  for (const token of tokens) {
    if (/^\w+:/.test(token) || STAT_TOKEN.test(token)) {
      syntaxTokens.push(token);
    } else {
      nameTokens.push(token);
    }
  }
  return { name: nameTokens.join(' '), syntax: syntaxTokens.join(' ') };
}
